import { Pager, type PagerProps } from "@progress/kendo-react-data-tools";

const PAGER_MESSAGES: Record<string, string> = {
  "pager.info": "{0} - {1} of {2} items",
  "pager.firstPage": "Go to the first page",
  "pager.previousPage": "Go to the previous page",
  "pager.nextPage": "Go to the next page",
  "pager.lastPage": "Go to the last page",
  "pager.itemsPerPage": "items per page",
  "pager.pageSelection": "Select page",
  "pager.page": "Page",
  "pager.of": "of",
  "pager.totalPages": "{0}",
  "pager.pageNumberLabel": "Type a page number",
  "pager.pageLabel": "Page",
  "pager.ariaKeyshortcuts": "Enter ArrowRight ArrowLeft",
  "pager.ariaLabel": "Pager",
  "pager.pageSizeAriaLabel": "Page size",
  "pager.mobileSelect": "Select",
  "pager.moreButtonLabel": "Skip 10 pages",
};

const pagerMessagesMap = (messageKey: string) => ({
  messageKey,
  defaultMessage: PAGER_MESSAGES[messageKey] ?? messageKey,
});

export default function AccessiblePager(props: PagerProps) {
  const { skip, take, total } = props;
  const from = total === 0 ? 0 : Math.min(skip + 1, total);
  const to = Math.min(skip + take, total);

  return (
    <>
      <Pager {...props} messagesMap={pagerMessagesMap} />
      <div role="status" aria-live="polite" className="visually-hidden">
        {total > 0 ? `Showing ${from} - ${to} of ${total} items` : ""}
      </div>
    </>
  );
}
